import styled from "styled-components"
import { Button_s, Colors } from "styles/app-styles"
import Isvg from 'react-inlinesvg'
import Modal from 'components/modal/basic-modal'
import { ModalTitle_s } from 'components/modal/modal-styles'

export const AddRemoveRow_s = styled.div`
  align-items: flex-end;
  height: 30px;
  > div {
    cursor: pointer;
    padding-bottom: 6px;
    svg {
      fill: ${Colors.blackPearl};
      height: 18px;
      width: 18px;
    }
  }
`

export const CarouselBtn_s = styled(Button_s)`
  align-items: center;
  background: inherit !important;
  border: none;
  display: flex;
  flex-direction: row;
  font-weight: normal;
  height: 100%;
  padding: 0;
  width: 100%;

  > div:last-child {
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: calc(100% - 20px);
  }

  svg { margin-right: 5px; }
`

export const CarouselModal_s = styled(Modal)`
  ${ModalTitle_s}{
    &:hover {
      cursor: move;
    }
  }
`

interface CarouselTriggerBtnProps {
  hasContent: boolean
}

export const CarouselTriggerButtons_s = styled.div<CarouselTriggerBtnProps>`
  background: ${Colors.white};
  border: 1px solid ${Colors.towerGrey};
  height: 28px;
  line-height: 27px;
  margin-top: -1px;
  text-align: center !important;
  width: 100% !important;
  ${props => props.hasContent && `
    &:after {
      border-radius: 100%;
      background-color: ${Colors.denim};
      content: "";
      height: 8px;
      margin: 4px 0 0 4px;
      position: absolute;
      width: 8px;
    }
  `}
`

export const CarouselIcon_s = styled(Isvg)`
  fill: ${Colors.darkDenim};
  height: 14px;
  // margin-left: 5px;
  width: 14px;
`

export const CarouselSave_s = styled(Button_s)`
  display: flex;
  margin: 15px 15px 0 auto;
`

export const CarouselTabs_s = styled.ul`
  border-bottom: 2px solid ${Colors.athensGrey};
  display: flex;
  flex-direction: row;
  height: 30px;
  padding: 0;
  li {
    background: inherit ;
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
    cursor: pointer;
    font-size: 14px;
    height: 30px;
    line-height: 20px;
    list-style: none;
    padding: 5px 10px;
    &:hover {
      font-weight: 500;
    }
    &[data-active="true"] {
      border-bottom: 2px solid ${Colors.blackPearl};
      font-weight: 500;
    }
    &[data-chosen="true"]{
      padding-right: 16px;
      &:after {
        border-radius: 100%;
        background-color: ${Colors.denim};
        content: "";
        height: 8px;
        margin-left: 2px;
        position: absolute;
        width: 8px;
      }
    }
  }
`

export const CarouselTrashIcon_s = styled.div`
  cursor: pointer;
  height: 18px;
  margin: 5px 0 5px auto;
  width: 18px;
  svg {
    height: 100%;
    width: 100%;
  }
`

export const SingleRowCarouselState_s = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: top;
  flex-wrap: nowrap;
  gap: 16px;
  > div {
    display: flex;
    flex-direction: column;
  }
  > div:not(:last-child) {
    margin-right: 0;
  }
  > .narrow {
    width: 150px;
  }
`

export const MultiRowCarouselState_s = styled(SingleRowCarouselState_s)`
  align-items: flex-end;
  margin-bottom: 10px;
  > div:last-child {
    flex-direction: row;
    > div {
      display: flex;
      flex-direction: column;
      margin-right: 10px;
    }
  }
  input {
    margin-bottom: 0 !important;
  }
`

export const CarouselSharedValue_s = styled.div`
  flex-direction: row;
  margin-bottom: 10px;
  > div > label { margin-right: 10px; }
`

export const PinIcon_s = styled(Isvg)`
  color: ${Colors.blackPearl};
  height: 18px;
  position: absolute;
  right: 32px;
  top: 5px;
  width: 18px;
  &#pinnedIcon {
    height: 22px;
    margin-top: -2px;
    width: 22px;
  }
`

export const CarouselContent_s = styled.div`
  min-height: 475px;
  label {
    color: ${Colors.blackPearl};
    font-size: 14px;
    margin-bottom: 10px;
  }
  .p-dropdown-items-wrapper {
    max-height: 100px !important;
  }
  ${AddRemoveRow_s}:first-child {
    margin-top: 25px;
  }
  ${SingleRowCarouselState_s}:last-child {
    padding-bottom: 135px;
  }
  > div {
    margin-top: 20px;
  }
`
